// extracted by mini-css-extract-plugin
module.exports = {"PurchaseTokensPage__Option":"PurchaseTokensPage__Option"};